<template>
  <div class="modal-backdrop-custom" @click.self="close">
    <div class="modal-box" style="width:520px; max-width:95vw;">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="fw-bold mb-0">API Key 관리 - {{ area?.AreaName }} (<code>{{ area?.AreaCode }}</code>)</h6>
        <button class="btn-close" @click="close"></button>
      </div>

      <div v-if="loading" class="text-center text-muted py-4">불러오는 중...</div>

      <div v-else>
        <div class="mb-3">
          <label class="form-label form-label-sm">API 활성화</label>
          <div>
            <span v-if="apiInfo.ApiEnabled" class="badge bg-success">활성</span>
            <span v-else class="badge bg-secondary">비활성</span>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label form-label-sm">현재 API Key</label>
          <div class="p-2 border rounded bg-light small" style="word-break:break-all; min-height:38px;">
            <span v-if="apiInfo.ApiKey">{{ apiInfo.ApiKey }}</span>
            <span v-else class="text-muted">발급된 키가 없습니다.</span>
          </div>
        </div>

        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-secondary btn-sm" @click="close">닫기</button>
          <button class="btn btn-danger btn-sm" :disabled="saving || !apiInfo.ApiKey" @click="confirmDelete">삭제</button>
          <button class="btn btn-primary btn-sm" :disabled="saving" @click="createKey">생성</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ApiKeyModal',
  props: {
    area: { type: Object, required: true }
  },
  data() {
    return {
      apiInfo: { ApiKey: null, ApiEnabled: 0 },
      loading: false,
      saving: false,
      error: null
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async fetch() {
      this.loading = true
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.area.AreaSeq}/apikey`)
        this.apiInfo = res.data || { ApiKey: null, ApiEnabled: 0 }
      } catch (e) {
        this.error = e.response?.data?.message || 'API 키를 불러오지 못했습니다.'
      } finally {
        this.loading = false
      }
    },
    async createKey() {
      if (!confirm('새 API Key를 생성하면 기존 키는 대체됩니다. 계속 진행합니까?')) return
      this.saving = true
      try {
        const res = await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.area.AreaSeq}/apikey`)
        this.apiInfo = res.data || { ApiKey: null, ApiEnabled: 1 }
      } catch (e) {
        alert(e.response?.data?.message || '생성에 실패했습니다.')
      } finally {
        this.saving = false
      }
    },
    async confirmDelete() {
      if (!confirm('API Key를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) return
      this.saving = true
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.area.AreaSeq}/apikey`)
        this.apiInfo = { ApiKey: null, ApiEnabled: 0 }
      } catch (e) {
        alert(e.response?.data?.message || '삭제에 실패했습니다.')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.modal-backdrop-custom { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:1050 }
.modal-box { background:#fff; border-radius:10px; padding:1.5rem; width:420px; max-width:95vw; box-shadow:0 8px 30px rgba(0,0,0,0.2) }
</style>
